import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const aiEngineeringRoadmapUrl = 'https://mangrove-swallow-b5e.notion.site/AI-Engineering-Roadmap-By-Uddeshya-Barnwal-2b7c4838a0a280429c5ad3233bba0b80?pvs=74';

const blogPosts = [
  {
    id: 1,
    title: '1. Building Agentic Platforms (Not AI Demos)',
    url: 'https://uddeshyabarnwal.substack.com/p/building-agentic-platforms-not-ai'
  },
  {
    id: 2,
    title: '2. The Runtime System Behind Every Production AI Agent',
    url: 'https://uddeshyabarnwal.substack.com/p/2-the-runtime-system-behind-every'
  },
  {
    id: 3,
    title: '3. Inside the LLM Control Plane',
    url: 'https://uddeshyabarnwal.substack.com/p/inside-the-llm-control-plane'
  },
  {
    id: 4,
    title: '4. Cost Is a Runtime Constraint, Not a Finance Problem',
    url: 'https://uddeshyabarnwal.substack.com/p/4-cost-is-a-runtime-constraint-not'
  },
  {
    id: 5,
    title: "5. Caching in LLM Systems (Why It's Not Just Redis)",
    url: 'https://uddeshyabarnwal.substack.com/p/5-caching-in-llm-systems-why-its'
  },
  {
    id: 6,
    title: '6. Observability - Traces, p95, and Knowing Why Agents Misbehave',
    url: 'https://uddeshyabarnwal.substack.com/p/6-observability-traces-p95-and-knowing'
  },
  {
    id: 7,
    title: '7. Reliability - Failover, Model Switching, and Graceful Degradation',
    url: 'https://uddeshyabarnwal.substack.com/p/7-reliability-failover-model-switching'
  }
];

const ComingSoon = () => {
  return (
    <div className="min-h-screen bg-[#FAFAF8] flex items-center justify-center px-6 py-16">
      <div className="max-w-3xl mx-auto text-center space-y-8">
        <div className="space-y-8 text-left">
          <div className="space-y-3">
            <h2 className="font-serif text-2xl text-[#1A1A1A]">AI Engineering Roadmap</h2>
            <a
              href={aiEngineeringRoadmapUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="text-teal-700 hover:text-teal-800 underline underline-offset-2 transition-colors"
            >
              AI Engineering Roadmap
            </a>
          </div>

          <div className="space-y-3">
            <h2 className="font-serif text-2xl text-[#1A1A1A]">AI Agentic Platform</h2>
            <ul className="space-y-3">
              {blogPosts.map((post) => (
                <li key={post.id}>
                  <a
                    href={post.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-teal-700 hover:text-teal-800 underline underline-offset-2 transition-colors"
                  >
                    {post.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Back to Home Button */}
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 bg-teal-600 text-white rounded-sm hover:bg-teal-700 transition-all duration-300 font-medium shadow-sm hover:shadow-md"
        >
          <ArrowLeft size={20} />
          Back to Home
        </Link>
      </div>
    </div>
  );
};

export default ComingSoon;
